interface AuditJsonViewerProps {
	value: Record<string, unknown> | null
}

export function AuditJsonViewer({ value }: AuditJsonViewerProps) {
	if (!value || Object.keys(value).length === 0) {
		return <div className="text-sm text-muted-foreground">无</div>
	}

	return (
		<pre className="max-h-72 overflow-auto rounded-md bg-muted p-3 text-xs leading-relaxed">
			{JSON.stringify(value, null, 2)}
		</pre>
	)
}
